import { render, staticRenderFns } from "./BundleItems.vue?vue&type=template&id=3200b388"
import script from "./BundleItems.vue?vue&type=script&lang=js"
export * from "./BundleItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports